<template>
  <ActionsMenu>
    <delete-community :community-id="community.id" />
    <unreport-community :community-id="community.id" />
  </ActionsMenu>
</template>

<script>
import ActionsMenu from '../shared/ActionsMenu'
import UnreportCommunity from './UnreportCommunity'
import DeleteCommunity from './DeleteCommunity'

export default {
  name: 'AdminCommunityActionsMenu',
  components: { ActionsMenu, UnreportCommunity, DeleteCommunity },
  props: {
    community: {
      type: Object,
      required: true
    }
  }
}
</script>
